import { NgClass } from '@angular/common'
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core'
import { WhatsAppInviteTemplateModel } from '@app/v2/event/types/whatsapp-invite-template.model'
import { WhatsAppInviteTemplateId } from '@app/v2/event/types/whatsapp-invite-template.type'

/**
 * Invitation-tracker WhatsApp template picker: three predefined image previews (Tailwind tabs).
 */
@Component({
  selector: 'app-whatsapp-invite-templates',
  standalone: true,
  imports: [NgClass],
  templateUrl: './whatsapp-invite-templates.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WhatsAppInviteTemplatesComponent {
  public readonly selectedTemplateId = input(WhatsAppInviteTemplateModel.DEFAULT_TEMPLATE_ID, { transform: WhatsAppInviteTemplateModel.templateIdOrDefault })
  public readonly selectedTemplateIdChange = output<WhatsAppInviteTemplateId>()

  public readonly templates = WhatsAppInviteTemplateModel.PREVIEWS
  public readonly activePreviewUrl = computed(() => WhatsAppInviteTemplateModel.previewUrlFor(this.selectedTemplateId()))

  /**
   * Selects a template tab and emits the new id when it changes.
   * @param id - Template id (1–3).
   */
  public onSelectTemplate(id: WhatsAppInviteTemplateId): void {
    if (id === this.selectedTemplateId()) return
    this.selectedTemplateIdChange.emit(id)
  }

  /**
   * Tab button classes for active / inactive underline styling.
   * @param id - Template id for this tab.
   */
  public tabButtonClass(id: WhatsAppInviteTemplateId): Record<string, boolean> {
    const isActive = this.selectedTemplateId() === id
    return {
      'tw-border-blue-600': isActive,
      'tw-text-blue-600': isActive,
      'tw-border-transparent': !isActive,
      'tw-text-gray-500': !isActive
    }
  }
}
